import { createSlice } from "@reduxjs/toolkit";
import { fetchProjectManagerResourceRequestRequestLog } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const ProjectManagerResourceRequestRequestLogSlice = createSlice({
  name: "ProjectManagerResourceRequestRequestLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectManagerResourceRequestRequestLog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectManagerResourceRequestRequestLog.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProjectManagerResourceRequestRequestLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch fetch Project Manager Request Log  List";
      });
  },
});

export default ProjectManagerResourceRequestRequestLogSlice.reducer;
